module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-05.852558a5.svg";